import { render, staticRenderFns } from "./b_matchList.vue?vue&type=template&id=780c37b8&scoped=true&"
import script from "./b_matchList.vue?vue&type=script&lang=js&"
export * from "./b_matchList.vue?vue&type=script&lang=js&"
import style0 from "./b_matchList.vue?vue&type=style&index=0&id=780c37b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c37b8",
  null
  
)

export default component.exports